// like .closest(), but returns all matching parent elements
export function closestAll(
  element: HTMLElement,
  matcher: string,
  matches: Set<HTMLElement> = new Set(),
): HTMLElement[] {
  let matchedElem = element.closest<HTMLElement>(matcher);
  if (matchedElem) {
    matches.add(matchedElem);
    const parent = matchedElem.parentElement;
    return parent ? closestAll(parent, matcher, matches) : [];
  }
  return Array.from(matches);
}
